import LandingLogo from '@/assets/images/landing-logo.webp';
import GreenStar from '@/assets/images/green-star.webp';
import './logo.css';

export const Logo = () => {
    return (
        <div
            className="logo__container"
            style={
                {
                    '--logo-container-bg': `url(${GreenStar})`,
                } as React.CSSProperties
            }
        >
            <img className="logo" src={LandingLogo} alt="Goosicorn Racing Logo" />
        </div>
    );
};
